import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "d-flex align-items-center ml-1 ml-lg-0" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "mb-0 text-muted d-block" }
const _hoisted_6 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_7 = ["href", "title"]
const _hoisted_8 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "d-block text-muted"
}
const _hoisted_13 = {
  key: 1,
  class: "d-block text-success prefix-min"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "col-md-10 col-lg-8 col-xl-6 ml-auto pr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createBlock(_component_Card, null, _createSlots({
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.vm.editing
							? _ctx.$t("myCadac.contractDetail.card.titleChange")
							: _ctx.$t("myCadac.contractDetail.card.titleView")), 1),
        (_ctx.vm.supportProductUrl && _ctx.vm.contract.isSupportContract)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-success",
              label: _ctx.$t('myCadac.contractDetail.button.addProduct'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
						_ctx.openUrl(_ctx.vm.supportProductUrl);
						$event.target.disabled = true;
					})
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        "auto-layout": "",
        "data-key": "serialNumber",
        "edit-mode": _ctx.vm.editing ? 'cell' : '',
        "responsive-layout": "stack",
        value: _ctx.editingContractLines,
        onCellEditComplete: _ctx.onCellEditComplete
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "productName",
            header: _ctx.$t('myCadac.contractDetail.table.colProductName')
          }, {
            body: _withCtx((item) => [
              _createElementVNode("div", _hoisted_3, [
                (item.data.icon)
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 0,
                      alt: item.data.iconAlt,
                      class: "mr-1 bg-transparent flex-shrink-0",
                      image: item.data.icon,
                      shape: "square",
                      size: "large",
                      title: item.productName
                    }, null, 8, ["alt", "image", "title"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("small", _hoisted_5, _toDisplayString(item.data.productBrand), 1),
                  (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _createElementVNode("a", {
                          href: item.data.crmUrl,
                          target: "_blank",
                          title: _ctx.$t('common.goToCrm')
                        }, _toDisplayString(_ctx.formatProductName(item.data.productName, item.data.productBrand)), 9, _hoisted_7)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.formatProductName(item.data.productName, item.data.productBrand)), 1))
                ])
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            class: _normalizeClass({ 'text-right': _ctx.isSupportContract }),
            field: "serialNumber",
            header: _ctx.$t('myCadac.contractDetail.table.colProductSerialNumber')
          }, null, 8, ["class", "header"]),
          (!_ctx.isSupportContract)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "deployment",
                header: _ctx.$t('myCadac.contractDetail.table.colProductLicenceType')
              }, {
                body: _withCtx((item) => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`enum.deployment.${item.data.deployment}`)), 1)
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (!_ctx.isSupportContract)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 1,
                field: "seats",
                header: _ctx.$t('myCadac.contractDetail.table.colProductSeats')
              }, {
                editor: _withCtx((item) => [
                  (_ctx.vm.editing && item.data.canAddSeats)
                    ? _withDirectives((_openBlock(), _createBlock(_component_InputNumber, {
                        key: 0,
                        modelValue: item.data.seats,
                        "onUpdate:modelValue": ($event: any) => ((item.data.seats) = $event),
                        disabled: _ctx.showSpinner[item.index] || _ctx.isLoading,
                        max: 999,
                        min: item.data.seatsMinimal,
                        "show-buttons": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "min"])), [
                        [_directive_debounce, _ctx.onInputChanged, "300ms"]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.data.seats), 1))
                ]),
                body: _withCtx((item) => [
                  (_ctx.vm.editing && item.data.canAddSeats)
                    ? (_openBlock(), _createBlock(_component_InputNumber, {
                        key: 0,
                        disabled: _ctx.showSpinner[item.index] || _ctx.isLoading,
                        "model-value": item.data.seats,
                        readonly: "",
                        "show-buttons": ""
                      }, null, 8, ["disabled", "model-value"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.data.seats), 1))
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (_ctx.vm.editing && !_ctx.isSupportContract && (_ctx.isLoading || _ctx.priceChanged))
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 2,
                class: "text-right pr-2",
                header: _ctx.$t('myCadac.contractDetail.table.colProductPrice')
              }, {
                body: _withCtx((item) => [
                  (
								!_ctx.showSpinner[item.index] &&
								item.data.canAddSeats &&
								item.data.price > 0 &&
								_ctx.seatsChangedForItem(item.data)
							)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (item.data.priceBase !== item.data.price)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_12, [
                              _createElementVNode("s", null, _toDisplayString(_ctx.formatCurrency(item.data.priceBase)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.data.discount > 0)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.formatCurrency(item.data.discount)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(item.data.price)), 1)
                      ]))
                    : (_ctx.showSpinner[item.index])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["edit-mode", "value", "onCellEditComplete"])
    ]),
    _: 2
  }, [
    (_ctx.vm.editing && _ctx.priceChanged)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"]),
              _createVNode(_component_Button, {
                class: "p-button-success p-button-raised p-button-lg d-block ml-auto",
                disabled: !_ctx.canCheckout,
                label: _ctx.$t('myCadac.contractDetail.button.goToCheckout'),
                loading: _ctx.isLoading,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCheckoutClick()))
              }, null, 8, ["disabled", "label", "loading"])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}